import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import countriesReducer from './country/reducer';
import generalReducer from './general/reducer';
import listingReducer from './listing/reducer';
import transactionReducer from './transaction/redux';
import userReducer from './user/reducer';
import questionReducer from './question/reducer';
import notificationReducer from './notification/reducer';
import giveawayReducer from './giveaway/reducer';


const rootReducer = combineReducers({
    countriesReducer,
    user: userReducer,
    general: generalReducer,
    listing: listingReducer,
    transaction: transactionReducer,
    questionReducer: questionReducer,
    notificationReducer: notificationReducer,
    giveawayReducer: giveawayReducer
});
export const store = createStore(rootReducer, applyMiddleware(thunk));
export type RootStore = ReturnType<typeof rootReducer>